import React from "react";
import ReactGA from "react-ga4";

const GEMINI_IQ_URL = "https://staging-amplify.d2z5w4m72bxpgd.amplifyapp.com/mobile/mobile-docuchat";

class GeminiIQ extends React.Component {

	componentDidMount() {
		ReactGA.pageview(window.location.pathname);
	}

	render() {
		return (
			<div style={{ height: "calc(100vh - 165px)", minHeight: "650px", backgroundColor: "#1C1C1E" }}>
				<iframe
					src={GEMINI_IQ_URL}
					title="Gemini IQ"
					style={{
						width: "100%",
						height: "100%",
						border: "0",
						display: "block",
						backgroundColor: "#1C1C1E"
					}}
					allow="microphone; clipboard-read; clipboard-write"
				></iframe>
			</div>
		);
	}
}

export default GeminiIQ;
